import ReserveeModel from "../../models/ReserveeModel";

export default {
    reservee_delete(state, id) {
        const delIndex = state.model.reservees.findIndex(r => r._id === id);
        if (delIndex >= 0) {
            state.model.reservees.splice(delIndex, 1);
        }
        if(state.model.reservation.is_prepay == "1"){
            let sum=0;
            state.model.reservees.map(ele=>{
                sum+=(+ele.package_price)
            })
            state.model.reservation.prepay_total_packages_price = sum;
        }
    },
    reservee_save(state, model) {
        let saveItem = {...model};

        if (state.model.reservees.find(r => r._id === model._id)) {
            saveItem = state.model.reservees.find(r => r._id === model._id);
        } else {
            state.model.reservees.push(saveItem);
        }
        for (let key in model) {
            saveItem[key] = model[key];
        }
        if(state.model.reservation.is_prepay == "1"){
            let sum=0;
            state.model.reservees.map(ele=>{
                sum+=(+ele.package_price)
                // if (state.resources.config.special_fee_at_checkout == 1) {
                //     sum += parseFloat(state.resources.config.special_fixed_fee);
                // }
            })
            state.model.reservation.prepay_total_packages_price = sum;
        }
    },
    reservee_update(state, payload) {
        for (let key in payload) {
            state.model.reservees[key]['id'] = payload[key]['id'];
        }
    },


    reservation_update(state, payload) {
        for (let key in payload) {
            state.model.reservation[key] = payload[key];
        }
    },


    cost_update(state, payload) {
        for (let key in payload) {
            state.model.cost[key] = payload[key];
        }
    },


    set_reservees_number(state) {
        let diff = state.model.reservation.reservees_number - state.model.reservees.length;
        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                state.model.reservees.push(new ReserveeModel());
            }
        }

    }
}
